import { render, staticRenderFns } from "./payment-order-view.vue?vue&type=template&id=38cae0dc&scoped=true&"
import script from "./payment-order-view.vue?vue&type=script&lang=ts&"
export * from "./payment-order-view.vue?vue&type=script&lang=ts&"
import style0 from "./payment-order-view.vue?vue&type=style&index=0&id=38cae0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cae0dc",
  null
  
)

export default component.exports